



























import Vue from 'vue';
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import CompanyListEntry from "../../models/company/CompanyListEntry";
import AsiAutocomplete from "../common/AsiAutocomplete";
import {enumTextFromValue} from "@/helpers/functions_asi";
import {CompanyState, CompanyType} from "@/helpers/constants";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import {Icon} from "@/helpers/icons";
import CompanyListFilter from "@/models/company/CompanyListFilter";

@Component({
	components: {AsiAvatar, AsiAutocomplete}
})
export default class CompanyAutocompleteInput extends Vue {

	@Prop({type: String, default: null})
	public value!: string | string[] | null;

	@Prop({type: Array, default: () => []})
	public companies!: CompanyListEntry[];

	@Prop({type: Object, default: null})
	public companyListFilter!: CompanyListFilter | null;

	@Prop({type: Array, default: () => []})
	public rules!: (string | null | number | object | unknown | boolean)[];

	@Prop({type: Boolean, default: false})
	public clearable!: boolean;

	@Prop({type: Boolean, default: false})
	public disabled!: boolean;

	@Prop({type: Boolean, default: false})
	public multiple!: boolean;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	@Prop({type: Boolean, default: false})
	public simple!: boolean;

	private loadingInternal: boolean = false;
	private companiesInternal: CompanyListEntry[] = [];
	private icons = Icon;
	private companyListFilterInternal: CompanyListFilter | null = null;

	private get loadingActual(): boolean {
		return this.loading || this.loadingInternal;
	}

	public mounted(): void {
		if (this.companies.length > 0) {
			this.companiesInternal = this.companies;
			this.companyOptionsChanged();
		} else {
			this.setCompanyListFilterInternal();
			this.loadCompanies();
		}
	}

	@Emit('input')
	public input(event: Event): Event {
		return event;
	}

	@Emit('change')
	public change(event: Event): Event {
		return event;
	}

	@Emit('companyOptionsChanged')
	public companyOptionsChanged(): CompanyListEntry[] {
		return this.companiesInternal;
	}

	@Watch('companies', {deep: true})
	private onCompaniesChanged(value: CompanyListEntry[]): void {
		this.companiesInternal = value;
	}

	@Watch('companyListFilter', {deep: true})
	private onCompanyListFilterChanged(): void {
		this.setCompanyListFilterInternal();
		this.loadCompanies();
	}

	private setCompanyListFilterInternal(): void {
		this.companyListFilterInternal = this.companyListFilter ?? new CompanyListFilter();
		this.companyListFilterInternal.states = [CompanyState.active];
	}

	private loadCompanies(): void {
		this.loadingInternal = true;
		this.$companyService.companies(this.companyListFilterInternal, null)
			.then((data) => {
				this.companiesInternal = data.data;
				this.companyOptionsChanged();
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.loadingInternal = false;
			})
	}

	private companyTypeLabel(company: CompanyListEntry): string | null {
		return enumTextFromValue(CompanyType, company.type, true);
	}

	private companyAvatarUrl(company: CompanyListEntry): string | null {
		return CompanyListEntry.avatarUrlSmall(company);
	}

}
